import { Spinner } from 'react-bootstrap';
import React from 'react';
import { ServicesContext } from '~/services';
import { enumValue } from '~/util';

interface OpenLRProps {
    referralID?: string | undefined;
    isOutgoing?: boolean | undefined;
}

export function OpenLR({ referralID, isOutgoing }: OpenLRProps) {
    const services = React.useContext(ServicesContext);
    const [lrOpenLoading, setLrOpenLoading] = React.useState(false);

    async function openLrLink() {
        setLrOpenLoading(true);
        let path = 'refer?';
        if (referralID) {
            path = `referral/${referralID}?f=out&`;
        }
        if (isOutgoing) {
            path = 'referrals/outgoing?';
        }
        const result = await services.api.call({
            method: 'post',
            url: '/api/access-tokens',
            data: { type: enumValue(['user', 'tokens', 'Core App Auth Token']) },
        });
        window.open(
            `${result.data.host}/${path}zephyr_access_token=${result.data.token}`,
            '_blank'
        );
        setLrOpenLoading(false);
    }

    if (
        !services.user.hasFeatureToggle('openlr') ||
        !services.user.getExternalAccount('Core App')
    ) {
        return null;
    }

    return (
        <button
            type="button"
            className="btn btn-info"
            onClick={openLrLink}
            disabled={lrOpenLoading}
        >
            {lrOpenLoading && (
                <Spinner
                    animation="border"
                    variant="light"
                    size="sm"
                    role="status"
                    className="me-1"
                />
            )}
            Open LeadingReach
            <i className="fa-solid fa-external-link ms-2" />
        </button>
    );
}
